"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _DropdownTrigger = require("../../primitives/DropdownTrigger");
var _useDropdownSelection = require("../hooks/useDropdownSelection");
var _common = require("./common.js");
var _useUISettings = require("../AppData/useUISettings");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * wrap the button on click of whom settings should open, this component will take care of the rest,
 * it'll give the user options to change input/output device as well as check speaker.
 * There is also another controlled way of using this by passing in open and onOpenChange.
 */
var Settings = function Settings() {
  var _useDevices = (0, _reactSdk.useDevices)(),
    allDevices = _useDevices.allDevices,
    selectedDeviceIDs = _useDevices.selectedDeviceIDs,
    updateDevice = _useDevices.updateDevice;
  var videoInput = allDevices.videoInput,
    audioInput = allDevices.audioInput,
    audioOutput = allDevices.audioOutput;
  var videoTrackId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalVideoTrackID);
  var isVideoOn = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsLocalVideoEnabled);
  // don't show speaker selector where the API is not supported, and use
  // a generic word("Audio") for Mic. In some cases(Chrome Android for e.g.) this changes both mic and speaker keeping them in sync.
  var shouldShowAudioOutput = ("setSinkId" in HTMLMediaElement.prototype);
  var mirrorLocalVideo = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.mirrorLocalVideo);
  var trackSelector = (0, _reactSdk.selectVideoTrackByID)(videoTrackId);
  var track = (0, _reactSdk.useHMSStore)(trackSelector);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    className: (0, _common.settingOverflow)(),
    children: [videoInput !== null && videoInput !== void 0 && videoInput.length ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [isVideoOn && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoTile.Container, {
        css: {
          w: "90%",
          px: "$10",
          height: "$48",
          bg: "transparent",
          m: "$10 auto"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Video, {
          trackId: videoTrackId,
          mirror: (track === null || track === void 0 ? void 0 : track.facingMode) !== "environment" && mirrorLocalVideo
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DeviceSelector, {
        title: "Video",
        devices: videoInput,
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VideoOnIcon, {}),
        selection: selectedDeviceIDs.videoInput,
        onChange: function onChange(deviceId) {
          return updateDevice({
            deviceId: deviceId,
            deviceType: _reactSdk.DeviceType.videoInput
          });
        }
      })]
    }) : null, audioInput !== null && audioInput !== void 0 && audioInput.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(DeviceSelector, {
      title: shouldShowAudioOutput ? "Microphone" : "Audio",
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MicOnIcon, {}),
      devices: audioInput,
      selection: selectedDeviceIDs.audioInput,
      onChange: function onChange(deviceId) {
        return updateDevice({
          deviceId: deviceId,
          deviceType: _reactSdk.DeviceType.audioInput
        });
      }
    }) : null, audioOutput !== null && audioOutput !== void 0 && audioOutput.length && shouldShowAudioOutput ? /*#__PURE__*/(0, _jsxRuntime.jsx)(DeviceSelector, {
      title: "Speaker",
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SpeakerIcon, {}),
      devices: audioOutput,
      selection: selectedDeviceIDs.audioOutput,
      onChange: function onChange(deviceId) {
        return updateDevice({
          deviceId: deviceId,
          deviceType: _reactSdk.DeviceType.audioOutput
        });
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TestAudio, {
        id: selectedDeviceIDs.audioOutput
      })
    }) : null]
  });
};
var DeviceSelector = function DeviceSelector(_ref) {
  var _devices$find, _ref$current;
  var title = _ref.title,
    devices = _ref.devices,
    selection = _ref.selection,
    onChange = _ref.onChange,
    icon = _ref.icon,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var selectionBg = (0, _useDropdownSelection.useDropdownSelection)();
  var ref = (0, _react.useRef)(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      mb: "$10"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        mb: "$4"
      },
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      css: {
        gap: "$4",
        "@md": {
          flexDirection: children ? "column" : "row",
          alignItems: children ? "start" : "center"
        }
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          position: "relative",
          flex: "1 1 0",
          w: "100%",
          minWidth: 0,
          "@md": {
            mb: children ? "$8" : 0
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
          open: open,
          onOpenChange: setOpen,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownTrigger.DialogDropdownTrigger, {
            ref: ref,
            css: _objectSpread({}, children ? {
              flex: "1 1 0",
              minWidth: 0
            } : {}),
            icon: icon,
            title: ((_devices$find = devices.find(function (_ref2) {
              var deviceId = _ref2.deviceId;
              return deviceId === selection;
            })) === null || _devices$find === void 0 ? void 0 : _devices$find.label) || "Select device from list",
            open: open
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Portal, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Content, {
              align: "start",
              sideOffset: 8,
              css: {
                w: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth,
                zIndex: 1000
              },
              children: devices.map(function (device) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
                  onSelect: function onSelect() {
                    return onChange(device.deviceId);
                  },
                  css: {
                    px: "$9",
                    bg: device.deviceId === selection ? selectionBg : undefined
                  },
                  children: device.label
                }, device.label);
              })
            })
          })]
        })
      }), children]
    })]
  });
};
var TEST_AUDIO_URL = "https://100ms.live/test-audio.wav";
var TestAudio = function TestAudio(_ref3) {
  var id = _ref3.id;
  var audioRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    playing = _useState4[0],
    setPlaying = _useState4[1];
  (0, _react.useEffect)(function () {
    if (audioRef.current && id) {
      try {
        if (typeof audioRef.current.setSinkId !== "undefined") {
          audioRef.current.setSinkId(id);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [id]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
      variant: "standard",
      css: {
        flexShrink: 0,
        p: "$6 $9",
        "@md": {
          w: "100%"
        }
      },
      onClick: function onClick() {
        var _audioRef$current;
        return (_audioRef$current = audioRef.current) === null || _audioRef$current === void 0 ? void 0 : _audioRef$current.play();
      },
      disabled: playing,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SpeakerIcon, {}), "\xA0Test", " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        as: "span",
        css: {
          display: "none",
          "@md": {
            display: "inline"
          }
        },
        children: "\xA0 speaker"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("audio", {
      ref: audioRef,
      src: TEST_AUDIO_URL,
      onEnded: function onEnded() {
        return setPlaying(false);
      },
      onPlay: function onPlay() {
        return setPlaying(true);
      }
    })]
  });
};
var _default = Settings;
exports["default"] = _default;